module.exports = __webpack_public_path__ + "img/footer.e8f5be04.png";